var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 420.281,
    height: 420.688,
    viewBox: "0 0 420.281 420.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      filter: url(#filter);\n      }\n\n      .cls-2 {\n      filter: url(#filter-2);\n      }\n\n      .cls-3, .cls-4, .cls-6 {\n      fill-rule: evenodd;\n      }\n\n      .cls-3 {\n      fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n      fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n      filter: url(#filter-3);\n      }\n\n      .cls-6 {\n      fill: #fefefe;\n      filter: url(#filter-4);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.828
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodOpacity: 0.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 5,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 6.083
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodOpacity: 0.04
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 640.39,
    y1: 738.438,
    x2: 640.39,
    y2: 332.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: -0.05,
    stopColor: "#20b038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.05,
    stopColor: "#67d670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 640.39,
    y1: 745.719,
    x2: 640.39,
    y2: 325.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 5,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodOpacity: 0.06
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4",
    x: 528,
    y: 431,
    width: 227,
    height: 210,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.236
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodOpacity: 0.07
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp_Logo",
    "data-name": "WhatsApp Logo",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WA_Logo",
    "data-name": "WA Logo",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.526,738.43l28.66-104.285a200.313,200.313,0,0,1-26.965-100.61C439.265,422.574,529.89,332.3,641.241,332.3a201.665,201.665,0,0,1,202.02,201.4c-0.045,110.96-90.678,201.244-202.018,201.244H641.16a202.468,202.468,0,0,1-96.54-24.5Z",
    transform: "translate(-430.25 -325.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M430.25,745.714l29.688-108.025A207.494,207.494,0,0,1,432.005,533.47c0.046-114.941,93.922-208.453,209.266-208.453A208.9,208.9,0,0,1,850.537,533.634C850.491,648.577,756.607,742.1,641.274,742.1h-0.086a209.759,209.759,0,0,1-100-25.373Zm116.075-66.73,6.351,3.755A174.167,174.167,0,0,0,641.2,706.891h0.071c95.868,0,173.894-77.727,173.932-173.269a173.627,173.627,0,0,0-173.863-173.4c-95.94,0-173.967,77.721-174,173.255a172.4,172.4,0,0,0,26.593,92.213l4.136,6.553L480.5,696.186Z",
    transform: "translate(-430.25 -325.031)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M588.97,446.324c-3.916-8.677-8.037-8.853-11.764-9-3.048-.127-6.536-0.12-10.021-0.12a19.243,19.243,0,0,0-13.944,6.521c-4.793,5.212-18.3,17.814-18.3,43.452s18.736,50.408,21.35,53.883,36.175,57.77,89.323,78.654c44.169,17.354,53.158,13.9,62.744,13.035s30.936-12.6,35.293-24.768,4.357-22.6,3.05-24.771-4.793-3.475-10.022-6.082-30.936-15.211-35.729-16.948-8.278-2.607-11.764,2.608-13.507,16.947-16.558,20.422-6.1,3.914-11.328,1.306-22.077-8.108-42.049-25.854c-15.543-13.811-26.038-30.871-29.088-36.087s-0.325-8.033,2.293-10.628c2.352-2.335,5.229-6.085,7.843-9.127s3.486-5.212,5.229-8.69,0.871-6.518-.436-9.126S593.62,456.627,588.97,446.324Z",
    transform: "translate(-430.25 -325.031)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.539eb7e1f470c0dbbbb4b2cd124711f2.svg";
export { ForwardRef as ReactComponent };